import * as constants from '../constants';

const initialState = {
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getRegions.success: {
            return action.payload;
        }

        case constants.getRegions.try:
        case constants.getRegions.error: {
            return initialState;
        }

        default:
            return state;
    }
}
